import { baseApi } from '@/store/baseApi';

import type {
  NotificationInboxData,
  NotificationInboxFilters,
  NotificationReadAllData,
  NotificationRealtimeTicket,
  NotificationStateMutationData,
} from '@/features/notifications/types';
import type { APIResponse } from '@web/types';

export const notificationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationInbox: builder.query<
      APIResponse<NotificationInboxData>,
      NotificationInboxFilters | void
    >({
      query: (params) => ({
        url: 'notifications/inbox',
        method: 'GET',
        params: params ?? undefined,
      }),
      providesTags: [{ type: 'Notifications', id: 'INBOX' }],
    }),

    markNotificationRead: builder.mutation<
      APIResponse<NotificationStateMutationData>,
      string
    >({
      query: (notificationId) => ({
        url: `notifications/inbox/${notificationId}/read`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'Notifications', id: 'INBOX' }],
    }),

    markAllNotificationsRead: builder.mutation<
      APIResponse<NotificationReadAllData>,
      void
    >({
      query: () => ({
        url: 'notifications/inbox/read-all',
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'Notifications', id: 'INBOX' }],
    }),

    archiveNotification: builder.mutation<
      APIResponse<NotificationStateMutationData>,
      string
    >({
      query: (notificationId) => ({
        url: `notifications/inbox/${notificationId}/archive`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'Notifications', id: 'INBOX' }],
    }),

    createNotificationsRealtimeTicket: builder.mutation<
      APIResponse<NotificationRealtimeTicket>,
      void
    >({
      query: () => ({
        url: 'realtime/tickets',
        method: 'POST',
        body: { purpose: 'notifications' },
      }),
    }),
  }),
});

export const {
  useGetNotificationInboxQuery,
  useMarkNotificationReadMutation,
  useMarkAllNotificationsReadMutation,
  useArchiveNotificationMutation,
  useCreateNotificationsRealtimeTicketMutation,
} = notificationsApi;
